<script lang="ts" setup>
import { capitalize } from 'lodash-es'
import { ENDPOINTS } from '~/config'
import { usePriorityFee } from '~/feautures/priority-fee'

const connectionStore = useConnectionStore()

const levels = ['fast', 'turbo', 'ultra']
const networks = ENDPOINTS

const priorityFee = usePriorityFee()
const level = toRef(priorityFee, 'level')
const rpc = ref()

const popover = ref(false)

watch(rpc, () => {
  if (rpc.value && (rpc.value !== connectionStore.endpoint?.id)) {
    connectionStore.setRpc(rpc.value)
  }
})

watch(() => connectionStore.endpoint, (ep) => {
  if (ep) {
    rpc.value = ep.id
  }
}, { immediate: true })
</script>

<template>
  <div class="app-settings">
    <i-app-settings :class="{ active: popover }" />
    <app-popover
      anchor="top middle" self="bottom middle"
      :transition-duration="100" class="settings-popover"
      :offset="[0, 8]"
      @show="popover = true"
      @hide="popover = false"
    >
      <div class="settings-menu">
        <div class="settings-menu__item title">
          Global Priority Fee
        </div>
        <div class="settings-menu__item priority-fee">
          <q-tabs v-model="level" class="default-tab text-teal" :animated="false">
            <q-tab v-for="t in levels" :key="t" :name="t" :label="capitalize(t)" />
          </q-tabs>
        </div>
        <div class="settings-menu__item title">
          Network RPC
        </div>
        <div class="settings-menu__item priority-fee settings-network">
          <q-tabs v-model="rpc" class="default-tab text-teal" :animated="false">
            <q-tab v-for="t in networks" :key="t.id" :name="t.id" :label="capitalize(t.name).replace('rpc', '')" />
          </q-tabs>
        </div>
      </div>
    </app-popover>
  </div>
</template>

<style lang="scss">
.app-settings {
  padding: $space-xs $space-lg;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  @media (max-width: $breakpoint-xs) {
    padding: 0 $space-sm;
  }

  @media (max-width: 360px) {
    padding: 0 $space-xxs 0 0;
  }

  svg {
    width: 32px;
    height: 32px;
    transition: 0.1s;

    @media (max-width: $breakpoint-xs) {
      width: 26px;
      height: 26px;
    }

    &.active {
      transform: rotate(20deg);
    }

    &:hover,
    &.active {
      opacity: 0.8;
    }
  }
}

.settings-popover {
  min-width: 244px;
  min-height: 144px;
  border-radius: 10px;
  padding: 0;

  .settings-menu {
    border-radius: 10px;
    background: rgba(32, 179, 149, 0.2);
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    &__item {
      &.title {
        font-size: 12px;
        font-weight: 700;
        line-height: 18px;
        color: $black;
        text-transform: uppercase;
      }

      &.show {
        display: none;

        @media (max-width: $breakpoint-sm) {
          display: flex;
        }
      }

      &.priority-fee {
        width: 100%;

        &:nth-child(2) {
          margin-bottom: 4px;
        }

        .q-tabs {
          width: 100%;
          background: $base-white;
          box-shadow: none;
          border-radius: 8px;
          padding: 4px;

          &__content {
            width: 100%;
            grid-template-columns: 1fr 1fr 1fr;
            height: 26px;
            border-radius: unset;

            .q-tab {
              height: auto;
              min-height: 100%;
              border-radius: 6px;
              position: relative;

              &:not(&:last-of-type):after {
                display: block;
                content: '';
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                width: 1px;
                height: 18px;
                background-color: $gray-02;
              }

              &:has(+ .q-tab--active):after {
                width: 0 !important;
              }

              &--active {
                background-color: $green;

                &:after {
                  display: none !important;
                }

                .q-tab__label {
                  color: $base-white;
                }
              }

              &__content {
                padding: 0;
              }

              &__indicator,
              .q-focus-helper {
                display: none;
              }
            }
          }

          .q-tab__label {
            font-size: 13px;
            font-weight: 600;
            text-transform: capitalize;
            color: $gray-01;
          }
        }
      }

      &.settings-network {
        .q-tab {
          flex: 1;
        }
      }
    }
  }
}
</style>
